import { Order } from '../Table/types';
import { Columns, HeadCell } from './types';

export const headCells: HeadCell[] = [
  {
    id: Columns.centerNumber,
    label: 'Associate School Number',
    order: Order.Asc,
  },
  { id: Columns.name, label: 'Name', order: Order.Asc },
  { id: Columns.status, label: 'Status', order: Order.Asc },
  { id: Columns.link, label: 'Actions', order: Order.NA },
];
